/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {OnDestroy, OnInit} from '@angular/core';

import {FormGroup} from '../model';

import {ControlContainer} from './control_container';
import {Form} from './form_interface';
import {composeAsyncValidators, composeValidators, controlPath} from './shared';
import {AsyncValidatorFn, ValidatorFn} from './validators';
/**
 * This is a base class for code shared between {\@link NgModelGroup} and {\@link FormGroupName}.
 * 
 * \@stable
 */
export class AbstractFormGroupDirective extends ControlContainer implements OnInit, OnDestroy {
/**
 * \@internal
 */
_parent: ControlContainer;
/**
 * \@internal
 */
_validators: any[];
/**
 * \@internal
 */
_asyncValidators: any[];
/**
 * @return {?}
 */
ngOnInit(): void {
    this._checkParentType(); /** @type {?} */((
    this.formDirective)).addFormGroup(this);
  }
/**
 * @return {?}
 */
ngOnDestroy(): void {
    if (this.formDirective) {
      this.formDirective.removeFormGroup(this);
    }
  }
/**
 * Get the {\@link FormGroup} backing this binding.
 * @return {?}
 */
get control(): FormGroup { return /** @type {?} */(( this.formDirective)).getFormGroup(this); }
/**
 * Get the path to this control group.
 * @return {?}
 */
get path(): string[] { return controlPath(this.name, this._parent); }
/**
 * Get the {\@link Form} to which this group belongs.
 * @return {?}
 */
get formDirective(): Form|null { return this._parent ? this._parent.formDirective : null; }
/**
 * @return {?}
 */
get validator(): ValidatorFn|null { return composeValidators(this._validators); }
/**
 * @return {?}
 */
get asyncValidator(): AsyncValidatorFn|null {
    return composeAsyncValidators(this._asyncValidators);
  }
/**
 * \@internal
 * @return {?}
 */
_checkParentType(): void {}
}

function AbstractFormGroupDirective_tsickle_Closure_declarations() {
/**
 * \@internal
 * @type {?}
 */
AbstractFormGroupDirective.prototype._parent;
/**
 * \@internal
 * @type {?}
 */
AbstractFormGroupDirective.prototype._validators;
/**
 * \@internal
 * @type {?}
 */
AbstractFormGroupDirective.prototype._asyncValidators;
}

